import styled from "styled-components";
import { MoreInfoWrapper } from "../../../style";
import { PageBox } from "../../../../../styles/page";

export const ReportWrapper = styled(PageBox)`
  border: 0.93px solid #d9d9d9;
  padding: 37px 30px;
`;

export const ReportHeader = styled.div`
  > .title {
    font-family: Pretendard;
    font-size: 23.16px;
    font-weight: 700;
    padding-bottom: 30px;
    border-bottom: 2px solid #d9d9d9;
  }
`;

export const ReportFilterWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 20px;

  > .radio {
    display: flex;
    gap: 12px;
    align-items: center;
  }
`;

export const ReportFilterHeader = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;

  > .name {
    height: 30px;
    width: 86px;
    padding: 6px;
    text-align: center;
    background: #ecf0f3;
    box-sizing: border-box;
    font-family: Pretendard;
    font-size: 15px;
    font-weight: 600;
    line-height: 17.9px;
    margin-right: 8px;
  }

  > .period {
    margin-right: 8px;
    font-family: Pretendard;
    font-size: 15px;
    font-weight: 500;
  }
`;

export const RadioBox = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  input[type="radio"] {
    appearance: none;
    width: 24px;
    height: 24px;
    border: 2px solid #d9d9d9;
    border-radius: 50%;
    background-color: #fff;
    vertical-align: bottom;
    cursor: pointer;
    margin: 0;
  }

  input[type="radio"]:checked {
    border: 1px solid #7f25fb;
    background-color: #7f25fb;
  }

  > img {
    position: absolute;
    top: 7px;
    left: 5px;
    pointer-events: none;
  }
`;

export const MainWrapper = styled.div`
  margin-top: 40px;
`;

export const PageContentHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  > .title {
    font-family: Pretendard;
    font-size: 19px;
    font-weight: 600;
  }
`;

export const ReportContentTable = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 12px;

  > .thead {
    display: flex;
    background: #ecf0f3;
    height: 30px;
    align-items: center;
  }

  > .tbody {
    display: flex;
    height: 30px;
  }
`;

export const ReportContentTableHeaderItem = styled.div<{ isLast: boolean }>`
  height: 30px;
  flex: 1;
  min-width: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  gap: 8px;
  font-family: Pretendard;
  font-weight: 600;
  font-size: 15px;

  > .more {
    cursor: pointer;
    width: 15px;
    height: 15px;

    > img {
      width: 100%;
      height: 100%;
    }
  }

  ${({ isLast }) => !isLast && `border-right: 1px solid #d9d9d9;`}
`;

export const ReportContentTableBodyItem = styled.div<{ isMore: boolean }>`
  flex: 1;
  min-width: 0;
  font-size: 15px;
  text-align: center;
  line-height: 30px;

  ${({ isMore }) =>
    isMore &&
    `
      font-family: Pretendard;
      font-weight: 600;
      font-size: 15px;
      text-decoration: underline;
      text-decoration-style: solid;
      color: #7f25fb;
      cursor: pointer;
  `}
`;

export const ReportMoreInfo = styled(MoreInfoWrapper)`
  left: -30px;
  top: 50px;

  > .info {
    > .box {
      font-family: Pretendard;
      font-size: 15px;
      font-weight: 500;
      flex-direction: row;
      display: flex;
      width: 100%;
      justify-content: space-between;
      gap: 20px;
      align-items: center;

      > .name {
        font-family: Pretendard;
        font-weight: 400;
      }

      &.weight {
        font-family: Pretendard;
        font-size: 17px;
        font-weight: 600;

        > .name {
          font-family: Pretendard;
          font-weight: 600;
          font-size: 17px;
        }
      }
    }
  }
`;

export const ReportGraphWrapper = styled.div`
  width: 1460px;
  height: 360px;
  position: relative;
  margin-top: 40px;

  #chartjs-tooltip {
    min-width: 302px;
    height: 171px;
    padding: 20px;
    border-radius: 10px;
    border: 0.93px solid #d9d9d9;
    box-shadow: 0px 3.71px 3.71px 0px #00000040;
    box-sizing: border-box;
    z-index: 10000;
    position: absolute;
    display: none;
    background: #fff;

    > .header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-family: Pretendard;
      font-size: 19px;
      font-weight: 700;
      margin-bottom: 20px;

      > .move-page {
        cursor: pointer;
      }
    }

    > .info-box {
      display: flex;
      flex-direction: column;
      gap: 12px;

      > .info {
        display: flex;
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-family: Pretendard;
        font-size: 15px;
        font-weight: 500;

        > .name {
          font-weight: 400;
        }
      }

      > .total {
        font-size: 17px;
        font-weight: 600;
      }
    }
  }
`;
